import { render, staticRenderFns } from "./NewsTree.vue?vue&type=template&id=66d6c0b3&scoped=true"
import script from "./NewsTree.vue?vue&type=script&lang=js"
export * from "./NewsTree.vue?vue&type=script&lang=js"
import style0 from "./NewsTree.vue?vue&type=style&index=0&id=66d6c0b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d6c0b3",
  null
  
)

export default component.exports